import { render } from "./SettingsBG.vue?vue&type=template&id=3269b2b2"
import script from "./SettingsBG.vue?vue&type=script&lang=js"
export * from "./SettingsBG.vue?vue&type=script&lang=js"
script.render = render

export default script